<template>
  <div class="remerciements-container col-sm-12">
    <div class="remerciements">
      <div class="row">
        <img class="bell-img ml-3 mr-3 mt-1" src="@/assets/bell.png" />
        <p class="remerciements-text-bold">
          {{ "remerciements_merci" | translate("fr") }}
        </p>
      </div>
      <p class="remerciements-text-normal mt-4">
        {{ "remerciements_text_1" | translate("fr") }}
      </p>
      <p class="remerciements-text-normal mt-4">
        {{ "remerciements_astt_text_2" | translate("fr") }}
      </p>
      <p class="remerciements-text-normal mt-4 mb-4">
        {{ "remerciements_text_3" | translate("fr") }}
      </p>

      <video-embed
        css="embed-responsive-16by9"
        src="https://www.youtube.com/watch?v=kFXT5BlA1mQ"
      ></video-embed>
    </div>
  </div>
</template>

<script>
import translations from "@/Translations.js";
export default {
  props: {
    locale: {
      type: String,
      default: "fr"
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  }
};
</script>

<style scoped>
.remerciements-container {
  display: flex;
  background-color: #ffffff;
  min-height: 200px;
}

.remerciements-text-bold {
  font-family: Lato;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.83;
  letter-spacing: normal;
  text-align: justify;
  color: #000000;
}

.remerciements-text-normal {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: justify;
  color: #000000;
}

.bell-img {
  width: 22px;
  height: 22px;
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .remerciements {
    margin: 5rem 10rem;
    width: 100%;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .remerciements {
    margin: 3rem 3rem;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .remerciements {
    margin: 50px 15px;
  }

  .remerciements-text-normal {
    font-size: 13px;
  }

  .remerciements-text-bold {
    font-size: 25px;
  }

  .bell-img {
    width: 20px;
    height: 20px;
  }
}
</style>
